import React from 'react';
import PropTypes from 'prop-types';
import { Img } from 'react-image';
import { uniqueId } from 'lodash';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';

// color .
import { grey } from '@material-ui/core/colors';

// style
import styles from '../style';

const useStyles = makeStyles(styles);

export default function CctvMedia(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { data } = props;
  const datas = [data];

  return (
    <>
      {datas && datas.map((row) => {
        let url = row.cctv_url;
        if (row.cctv_url === '') {
          url = row.cctv_flash;
        }
        return (
          <TableContainer key={uniqueId()}>
            <Table size="small">
              <TableHead />
              <TableBody>
                <TableRow>
                  <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={3}>
                    <Box fontWeight="500" fontFamily="Kanit" fontSize="14px">
                      {row.title}
                    </Box>
                    <Box fontFamily="Kanit" fontSize="12px">
                      {`${t('ต.')}${row.geocode.tumbon_name.th} ${t('อ.')}${row.geocode.amphoe_name.th} ${t('จ.')}${row.geocode.province_name.th}`}
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell padding="none" align="center" colSpan={3}>
                    <Box my={2} bgcolor={grey[300]} p={3}>
                      <Img
                        src={url}
                        alt={row.description}
                        loader={(<CircularProgress />)}
                        style={{ maxHeight: 500, width: '100%' }}
                        className={classes.imgCctv}
                        unloader={(
                          <Img
                            src="https://via.placeholder.com/300x250.png?text=No+Data"
                            width="100%"
                            height="100%"
                            alt="No Data"
                          />
                          )}
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        );
      })}
    </>
  );
}

CctvMedia.propTypes = {
  data: PropTypes.objectOf(Object).isRequired,
};
